import React from "react";
import ReactDOM from "react-dom";
import QuarterlyFinancialResults from "./containers/QuarterlyFinancialResults";
import { isEmpty } from "lodash";

export const initQuarterlyFinancialResults = className => {
  let elements = document.querySelectorAll(`.${className}`);
  if (!isEmpty(elements)) {
    for (let element of elements) {
      ReactDOM.render(<QuarterlyFinancialResults />, element);
    }
  }
};
